module.exports = __webpack_public_path__ + "img/realplayer_features10.68558517.svg";